import { useAuth } from '../../contexts/AuthContext';
import '../../Styles/Header/HeaderUpgradePrompt.css';
import { useChatContext } from '../../contexts/AppDataContext';

export const HeaderUpgradePrompt = () => {
    const auth = useAuth();
    const { setShowSalesModal } = useChatContext();

    const appDataLoading = typeof auth.isDataLoading !== "undefined" ? auth.isDataLoading : false;
    const authLoading = typeof auth.isLoading !== "undefined" ? auth.isLoading : false;

    if (authLoading || appDataLoading || auth.subscription || !auth.isAuthenticated) {
        return null;
    }

    return (
        <button type="button" className="header-upgrade-prompt" onClick={() => setShowSalesModal(true)}>
            Try Ultimate Free
        </button>
    )
}
